import AxiosConfig from '../Services/AxiosInstance'

  export function userLogin(params)
  { 
      return AxiosConfig.get("/api/Users/GetUserLog", { params });
  }
  export function GetUsersName()
  { 
      return AxiosConfig.get("/api/Users/getUserName");
  }
  export function GetUsersList()
  { 
      return AxiosConfig.get("/api/Users/GetUserRepor");
  }
  export function GetUsersPage()
  { 
      return AxiosConfig.get("/UserDetailsPage");
  }
  export function GetUserPageById(userId)
  { 
      return AxiosConfig.get(`/api/Users/GetUserRegReport?userId=${userId}`);
  } 

  export function AddUser(data)
  { 
      return AxiosConfig.get("/api/Users/add",data);
  } 

  export function EditUser(data){
    return AxiosConfig.get("/api/Users/UpdateUser",data);
  }
  export function ForgetPassword(data){
    return AxiosConfig.post("/api/Users/ForgetPassword",data);
  }
  export function resetpassword(data){
    return AxiosConfig.post("/api/Users/ResetPassword",data);
  }
  